var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._m(0),_c('portfolio-container',{staticClass:"portfolio"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heading"},[_c('h1',[_vm._v("my projects")]),_c('p',[_vm._v("click a card to view @ github")])])
}]

export { render, staticRenderFns }